var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.message)?_c('div',{staticClass:"card text-white bg-secondary mb-3"},[_c('div',{staticClass:"card-body py-2"},[(_vm.message)?_c('p',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.message.name))]):_vm._e()])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }